<template>
    <!-- アプリ情報 -->
    <fieldset id="mobileApp">
        <legend>モバイルアプリ情報:</legend>
        <div>
            テスト対象のモバイルアプリの情報を入力してください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. 初めてtestrun_mobileコマンドを実行する際は、「対象アプリ名」と「対象アプリパッケージ」と「対象アプリアクティビティ」を必ず入力してください。<br>
            2. 2回目のtestrun_mobileコマンド実行以降で、オプションを省略した場合、設定済みのデータを使用します。<br>
        </div>
        <div class="form-area">
            <label for="appName">・対象アプリ名</label><br>
            <input type="text" class="input-text" v-model="inputedAppName" name="appName" @input="updateOpt"
                placeholder="モバイルアプリ名"><br>
            <label for="appPackage">
                ・対象アプリパッケージ
            </label><br>
            <input type="text" class="input-text" v-model="inputedAppPackage" name="appPackage" @input="updateOpt"
                placeholder="com.android.chrome"><br>
            <label for="appActivity">
                ・対象アプリアクティビティ
            </label><br>
            <input type="text" class="input-text" v-model="inputedAppActivity" name="appActivity" @input="updateOpt"
                placeholder="com.google.android.apps.chrome.Main"><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

import strUtils from '@/js/strUtils';
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'MobileAppFormPackage',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedAppName = ref("")
        const inputedAppPackage = ref("")
        const inputedAppActivity = ref("")

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            let createdOpt = ""

            // アプリ情報
            if (inputedAppName.value) {
                createdOpt += ` --mobile_app_name ${inputedAppName.value}`
            }
            if (inputedAppPackage.value) {
                inputedAppPackage.value = await strUtils.replaceSlush(inputedAppPackage.value)
                createdOpt += ` --mobile_app_package ${inputedAppPackage.value}`
            }
            if (inputedAppActivity.value) {
                inputedAppActivity.value = await strUtils.replaceSlush(inputedAppActivity.value)
                createdOpt += ` --mobile_app_activity ${inputedAppActivity.value}`
                createdOpt += ` --mobile_app_kind app_package`
            }

            // cacheに保存
            await cacheUtils.saveData("mobileAppName", inputedAppName.value)
            await cacheUtils.saveData("mobileAppPackage", inputedAppPackage.value)
            await cacheUtils.saveData("mobileAppActivity", inputedAppActivity.value)
            
            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "mobileApp", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedAppName.value = await cacheUtils.getData("mobileAppName")
            inputedAppPackage.value = await cacheUtils.getData("mobileAppPackage")
            inputedAppActivity.value = await cacheUtils.getData("mobileAppActivity")
            await updateOpt()
        })

        return {
            // フォームデータ
            inputedAppName,
            inputedAppPackage,
            inputedAppActivity,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
